/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Col, Row } from 'antd';
import './styles.scss';
import { useState, memo } from 'react';

interface ModalHeaderProps {
  onCancel?: (() => void) | (() => void | undefined);
  caption?: React.ReactNode;
  search?: React.ReactNode;
  iconClose?: React.ReactNode;
  iconSearch?: React.ReactNode;
  // isSearhClicked?: boolean;
}

function ModalHeader({
  onCancel,
  caption,
  search,
  iconClose,
  iconSearch,
}: ModalHeaderProps) {
  const handleClick = () => {
    onCancel?.();
  };
  const [isSearchClicked, setIsSearchClicked] = useState(false);

  const handleSearchClick = () => {
    setIsSearchClicked(true);
  };

  return (
    <div>
      {!isSearchClicked ? (
        <Row className="flex justify-between items-center px-5 py-4 border-b-2 border-b-gray-200">
          <Col md={8} xs={17}>
            <div className="mt-2.5">{caption}</div>
          </Col>
          <Col md={13}>
            <div className="md:block hidden">{search}</div>
          </Col>
          <Col md={0} xs={4}>
            <div
              className="my-2.5 cursor-pointer flex justify-end hover:scale-105  md:hidden text-pink-800 dark:text-[#EB3E8E]"
              onClick={handleSearchClick}
            >
              {iconSearch}
            </div>
          </Col>
          {onCancel && (
            <Col md={3} xs={3}>
              <div
                className="my-2.5 flex justify-end text-pink-800 dark:text-[#EB3E8E]"
                onClick={handleClick}
              >
                {iconClose}
              </div>
            </Col>
          )}
        </Row>
      ) : (
        <Row className="flex justify-between px-2 py-4 border-b-2 w-full border-b-gray-100">
          <Col span={24}>
            <div className="md:hidden block">{search}</div>
          </Col>
          {onCancel && (
            <Col span={4}>
              <div
                className="my-1.5  flex justify-end text-pink-800"
                onClick={handleClick}
              >
                {iconClose}
              </div>
            </Col>
          )}
        </Row>
      )}
    </div>
  );
}

export default memo(ModalHeader);
